export interface DosGame {
  slug: string;
  series: string;
  seriesSlug: string;
  episode: number;
  title: string;
  blurb: string;
  bundleUrl: string;
  coverUrl: string;
  /** True if the bundle file has been added to web/public/dos/. False = "coming soon" tile. */
  available: boolean;
}

const COVER_EXT: Record<string, string> = {
  cosmo: 'png',
  'word-rescue': 'jpg',
  'math-rescue': 'jpg',
};

const game = (
  seriesSlug: string,
  series: string,
  episode: number,
  title: string,
  blurb: string,
  available = true,
): DosGame => ({
  slug: `${seriesSlug}-ep${episode}`,
  series,
  seriesSlug,
  episode,
  title,
  blurb,
  bundleUrl: `/dos/${seriesSlug}/ep${episode}.jsdos`,
  coverUrl: `/dos/${seriesSlug}/ep${episode}.${COVER_EXT[seriesSlug]}`,
  available,
});

export const GAMES: DosGame[] = [
  game('cosmo', "Cosmo's Cosmic Adventure", 1, 'Forbidden Planet', 'Cosmo crash-lands on Zoonati and uses his suction-cup hands to climb walls in search of his parents.'),
  game('cosmo', "Cosmo's Cosmic Adventure", 2, "Cosmo's Revenge", 'The adventure continues — bigger levels, meaner aliens.'),
  game('cosmo', "Cosmo's Cosmic Adventure", 3, 'Has He Met His Match?', 'The third and final episode of the Zoonati saga.'),

  game('word-rescue', 'Word Rescue', 1, 'Visit Gruzzleville', 'Match words to their pictures and rescue them from the Gruzzles in Gruzzleville and the Castle.'),
  game('word-rescue', 'Word Rescue', 2, 'GruzzleBad Caverns', 'Explore the dark caverns of the GruzzleBads to find more stolen words.'),
  game('word-rescue', 'Word Rescue', 3, 'The Haunted House', 'Brave the spooky haunted house in the final Word Rescue chapter.'),

  game('math-rescue', 'Math Rescue', 1, 'Math Rescue', 'Solve math puzzles to save numbers from the Gruzzles.'),
  game('math-rescue', 'Math Rescue', 2, 'Math Rescue II', 'More tricky problems, more Gruzzle-fighting fun.'),
  game('math-rescue', 'Math Rescue', 3, 'Math Rescue III', 'The grand finale of the Math Rescue trilogy.'),
];

export const GAMES_BY_SLUG: Record<string, DosGame> = Object.fromEntries(
  GAMES.map((g) => [g.slug, g]),
);

export interface GameSeries {
  seriesSlug: string;
  series: string;
  episodes: DosGame[];
}

export const SERIES: GameSeries[] = Array.from(
  GAMES.reduce((map, g) => {
    const existing = map.get(g.seriesSlug);
    if (existing) {
      existing.episodes.push(g);
    } else {
      map.set(g.seriesSlug, { seriesSlug: g.seriesSlug, series: g.series, episodes: [g] });
    }
    return map;
  }, new Map<string, GameSeries>()).values(),
);
